import { VueMaskFilter } from 'v-mask';

export const US_PHONE_MASK = '# ### ### #### ####';
export const formatByMask = (string, mask) => VueMaskFilter(string, mask);

export const formatUsPhone = phone => {
  if (!phone) return undefined;

  return `+${formatByMask(phone, US_PHONE_MASK)}`;
};

export const getFileFromPath = url =>
  url
    .substring(url.lastIndexOf('/') + 1)
    .split('?')
    .shift();

export const truncate = (string, numberOfChars) =>
  `${string.substring(0, numberOfChars)}${string.length > numberOfChars ? '... ' : ''}`;

export const initials = string => {
  const name = string.match(/\b\w/g) || [];
  return ((name.shift() || '') + (name.pop() || '')).toUpperCase();
};

export const capitalize = str => `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
